import { API_BASE_URL } from "../config/apiBase";
import { getAuthUserHeader } from "./userRoles";

export function normalizeStudentId(value) {
  return String(value || "").trim().toUpperCase();
}

export async function fetchTargetIdentity(studentId) {
  const normalizedStudentId = normalizeStudentId(studentId);
  if (!normalizedStudentId) throw new Error("Target Student ID is required.");

  const res = await fetch(
    `${API_BASE_URL}/api/admin/users/${encodeURIComponent(normalizedStudentId)}`,
    { cache: "no-store", headers: { "X-User": getAuthUserHeader() } }
  );
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error((data && (data.detail || data.error)) || "Target student not found.");
  }

  const user = data?.user || {};
  const resolvedStudentId = normalizeStudentId(user.student_id);
  if (resolvedStudentId !== normalizedStudentId) {
    throw new Error("Target student not found.");
  }
  return { studentId: resolvedStudentId, name: String(user.name || "").trim() };
}
